import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import KeyFeaturesWrapper from 'agency/digital_renderer/components/KeyFeaturesWrapper'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const KeyFeatures = (props) => {
  const { campaign } = props

  return (
    <KeyFeaturesWrapper
      campaign={campaign}
      render={({ features }) => (
        <div className={styles.root}>
          <ContentHolder>
            <Fade>
              <span>
                <h3 className={styles.title}>An overview of your property</h3>

                <h4 className={styles.subtitle}>Key Features</h4>

                <ul className={styles.features}>
                  {features.map(feature => (
                    <li key={feature}>&#x2014; {feature}</li>
                  ))}
                </ul>
              </span>
            </Fade>
          </ContentHolder>
        </div>
      )}
    />
  )
}

KeyFeatures.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default KeyFeatures
